export default class VerifyCodeRequestData {
  public code: string
  public receiver: string

  public constructor (code: string, receiver: string) {
    this.code = code
    this.receiver = receiver
  }
}
